import { render, staticRenderFns } from "./IconSvgMPANewsFeed.vue?vue&type=template&id=1b0ee62d&scoped=true&"
import script from "./IconSvgMPANewsFeed.vue?vue&type=script&lang=js&"
export * from "./IconSvgMPANewsFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ee62d",
  null
  
)

export default component.exports